import { Switch } from './Switch'

const components = {
  Switch,
}

export default components
